import {Component} from '@angular/core';
import {FieldArrayType, FormlyModule} from '@ngx-formly/core';

import {TranslateModule} from '@ngx-translate/core';
import {IonButton, IonCol, IonIcon, IonRow, IonText} from '@ionic/angular/standalone';

@Component({
    selector: 'string-formly-type',
    template: `
      <ion-row>
        <ion-col class="ion-no-padding">
          @if (props.label || props.description) {
            <div style="margin-top: 16px; margin-bottom: 16px;">
              <ion-text color="medium">
                @if (props.label) {
                  <h6 class="ion-no-margin">
                    {{ props.label }}
                  </h6>
                }
                @if (props.description) {
                  <div>
                    <small style="margin-top: 4px;">{{ props.description }}</small>
                  </div>
                }
              </ion-text>
            </div>
          }
        </ion-col>

        @if (showError && formControl.errors) {
          <ion-col class="ion-no-padding">
            <formly-validation-message [field]="field"></formly-validation-message>
          </ion-col>
        }
      </ion-row>

      @for (fieldGroup of field.fieldGroup; track fieldGroup; let i = $index) {
        <ion-row>
          <ion-col class="ion-no-padding ion-padding-bottom" size="10">
            <formly-field [field]="fieldGroup"></formly-field>
          </ion-col>
          <ion-col class="ion-no-padding ion-padding-bottom" size="2">
            <ion-button fill="clear" size="small" color="danger" (click)="remove(i)">
              <ion-icon slot="icon-only" name="remove-circle"></ion-icon>
            </ion-button>
          </ion-col>
        </ion-row>
      }

      <ion-row>
        <ion-col class="ion-no-padding ion-padding-bottom">
          <ion-button fill="clear" size="small" color="success" (click)="add()">
            <ion-icon slot="icon-only" name="add-circle"></ion-icon>
          </ion-button>
        </ion-col>
      </ion-row>
    `,
  imports: [TranslateModule, FormlyModule, IonIcon, IonButton, IonCol, IonRow, IonText]
})
export class ArrayFormlyType extends FieldArrayType {
}
